export const monitoringdata=[
  {
    "category": "jackson-databind@2.13.0",
    "title": "GHSA-rgv9-q543-rqg4",
    "exploitscore": "High",
    "stats": {
      "baseScore": 7.5,
      "exploitabilityScore": 3.9,
      "impactScore": 3.6
    },
    "fix": {
      "versions": [
        "2.13.4"
      ],
      "currentVersion": "2.13.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false,
      "lastUpdated": "2025-01-17T09:26:08.536Z"
    }
  },
  {
    "category": "jackson-databind@2.13.0",
    "title": "GHSA-jjjh-jjxp-wpff",
    "exploitscore": "High",
    "stats": {
      "baseScore": 7.5,
      "exploitabilityScore": 3.9,
      "impactScore": 3.6
    },
    "fix": {
      "versions": [
        "2.13.4.2"
      ],
      "currentVersion": "2.13.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": true,
      "lastUpdated": "2025-01-17T09:39:42.378Z"
    }
  },
  {
    "category": "jackson-databind@2.13.0",
    "title": "GHSA-57j2-w4cx-62h2",
    "exploitscore": "High",
    "stats": {
      "baseScore": 7.5,
      "exploitabilityScore": 3.9,
      "impactScore": 3.6
    },
    "fix": {
      "versions": [
        "2.13.2.1"
      ],
      "currentVersion": "2.13.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false,
      "lastUpdated": "2025-01-10T12:10:01.739Z"
    }
  },
  {
    "category": "jackson-databind@2.13.0",
    "title": "GHSA-3x8x-79m2-3w2w",
    "exploitscore": "High",
    "stats": {
      "baseScore": 7.5,
      "exploitabilityScore": 3.9,
      "impactScore": 3.6
    },
    "fix": {
      "versions": [
        "2.13.1"
      ],
      "currentVersion": "2.13.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "spring-web@5.3.10",
    "title": "GHSA-4wrc-f8pq-fpqp",
    "exploitscore": "Critical",
    "stats": {
      "baseScore": 9.8,
      "exploitabilityScore": 3.9,
      "impactScore": 5.9
    },
    "fix": {
      "versions": [
        "6.0.0"
      ],
      "currentVersion": "5.3.10",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false,
      "lastUpdated": "2025-01-08T09:19:30.652Z"
    }
  },
  {
    "category": "spring-web@5.3.10",
    "title": "GHSA-hgjh-9rj2-g67j",
    "exploitscore": "High",
    "stats": {
      "baseScore": 8.1,
      "exploitabilityScore": 2.8,
      "impactScore": 5.2
    },
    "fix": {
      "versions": [
        "5.3.33"
      ],
      "currentVersion": "5.3.10",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "spring-web@5.3.10",
    "title": "GHSA-ccgv-vj62-xf9h",
    "exploitscore": "High",
    "stats": {
      "baseScore": 8.1,
      "exploitabilityScore": 2.8,
      "impactScore": 5.2
    },
    "fix": {
      "versions": [
        "5.3.32"
      ],
      "currentVersion": "5.3.10",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "spring-web@5.3.10",
    "title": "GHSA-2wrp-6fg6-hmc5",
    "exploitscore": "High",
    "stats": {
      "baseScore": 8.1,
      "exploitabilityScore": 2.8,
      "impactScore": 5.2
    },
    "fix": {
      "versions": [
        "5.3.34"
      ],
      "currentVersion": "5.3.10",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false,
      "lastUpdated": "2025-01-08T09:21:16.236Z"
    }
  },
  {
    "category": "spring-web@5.3.10",
    "title": "GHSA-2rmj-mq67-h97g",
    "exploitscore": "Medium",
    "stats": {
      "baseScore": 5.3,
      "exploitabilityScore": 3.9,
      "impactScore": 1.4
    },
    "fix": {
      "versions": [
        "5.3.38"
      ],
      "currentVersion": "5.3.10",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN1D8C674C",
        "timestamp": "2025-01-11T21:56:14.920Z"
      },
      {
        "scanId": "SCAN9953FC4A",
        "timestamp": "2025-01-08T08:13:21.113Z"
      },
      {
        "scanId": "SCAN9EAEC58D",
        "timestamp": "2025-01-11T21:53:15.311Z"
      },
      {
        "scanId": "SCAN428099A7",
        "timestamp": "2025-01-16T05:39:56.975Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "laravel@v7.12.0",
    "title": "CVE-2021-21263",
    "exploitscore": "High",
    "stats": {
      "baseScore": 5,
      "exploitabilityScore": 10,
      "impactScore": 2.9
    },
    "fix": {
      "versions": [
        "6.20.11",
        "7.30.2",
        "8.22.1"
      ],
      "currentVersion": "v7.12.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN7246A50F",
        "timestamp": "2025-01-12T17:45:32.421Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "laravel@v7.12.0",
    "title": "CVE-2020-24941",
    "exploitscore": "High",
    "stats": {
      "baseScore": 4.3,
      "exploitabilityScore": 8.6,
      "impactScore": 2.9
    },
    "fix": {
      "versions": [
        "6.18.35",
        "7.24.0"
      ],
      "currentVersion": "v7.12.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN7246A50F",
        "timestamp": "2025-01-12T17:45:32.421Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "laravel@v7.12.0",
    "title": "CVE-2020-24940",
    "exploitscore": "High",
    "stats": {
      "baseScore": 4.3,
      "exploitabilityScore": 8.6,
      "impactScore": 2.9
    },
    "fix": {
      "versions": [
        "6.18.34",
        "7.23.2"
      ],
      "currentVersion": "v7.12.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN7246A50F",
        "timestamp": "2025-01-12T17:45:32.421Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "laravel@v7.12.0",
    "title": "CVE-2024-52301",
    "exploitscore": "Unknown",
    "stats": {
      "baseScore": 0,
      "exploitabilityScore": 0,
      "impactScore": 0
    },
    "fix": {
      "versions": [
        "10.48.23",
        "11.31.0",
        "6.20.45",
        "7.30.7",
        "8.83.28",
        "9.52.17"
      ],
      "currentVersion": "v7.12.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCAN7246A50F",
        "timestamp": "2025-01-12T17:45:32.421Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "log4j-core@2.14.1",
    "title": "GHSA-jfh8-c2jp-5v3q",
    "exploitscore": "Critical",
    "stats": {
      "baseScore": 10,
      "exploitabilityScore": 3.9,
      "impactScore": 6
    },
    "fix": {
      "versions": [
        "2.15.0"
      ],
      "currentVersion": "2.14.1",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCANDFFD965C",
        "timestamp": "2025-01-15T11:30:54.917Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "log4j-core@2.14.1",
    "title": "GHSA-7rjr-3q55-vv33",
    "exploitscore": "Critical",
    "stats": {
      "baseScore": 9,
      "exploitabilityScore": 2.2,
      "impactScore": 6
    },
    "fix": {
      "versions": [
        "2.16.0"
      ],
      "currentVersion": "2.14.1",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCANDFFD965C",
        "timestamp": "2025-01-15T11:30:54.917Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "log4j-core@2.14.1",
    "title": "GHSA-p6xc-xr62-6r2g",
    "exploitscore": "High",
    "stats": {
      "baseScore": 8.6,
      "exploitabilityScore": 3.9,
      "impactScore": 4
    },
    "fix": {
      "versions": [
        "2.17.0"
      ],
      "currentVersion": "2.14.1",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCANDFFD965C",
        "timestamp": "2025-01-15T11:30:54.917Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "log4j-core@2.14.1",
    "title": "GHSA-8489-44mv-ggj8",
    "exploitscore": "Medium",
    "stats": {
      "baseScore": 6.6,
      "exploitabilityScore": 0.7,
      "impactScore": 5.9
    },
    "fix": {
      "versions": [
        "2.17.1"
      ],
      "currentVersion": "2.14.1",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCANDFFD965C",
        "timestamp": "2025-01-15T11:30:54.917Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "log4j-core@2.16.0",
    "title": "GHSA-p6xc-xr62-6r2g",
    "exploitscore": "High",
    "stats": {
      "baseScore": 8.6,
      "exploitabilityScore": 3.9,
      "impactScore": 4
    },
    "fix": {
      "versions": [
        "2.17.0"
      ],
      "currentVersion": "2.16.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCANDFFD965C",
        "timestamp": "2025-01-15T11:30:54.917Z"
      }
    ],
    "status": {
      "fixed": false
    }
  },
  {
    "category": "log4j-core@2.16.0",
    "title": "GHSA-8489-44mv-ggj8",
    "exploitscore": "Medium",
    "stats": {
      "baseScore": 6.6,
      "exploitabilityScore": 0.7,
      "impactScore": 5.9
    },
    "fix": {
      "versions": [
        "2.17.1"
      ],
      "currentVersion": "2.16.0",
      "state": "fixed"
    },
    "scans": [
      {
        "scanId": "SCANDFFD965C",
        "timestamp": "2025-01-15T11:30:54.917Z"
      }
    ],
    "status": {
      "fixed": false
    }
  }
]